import React from "react";
import { useRouter } from 'next/router'
import styles from "../../../styles/pages/botStore.module.scss";
import { imageBaseURL } from "../../../data/createBotForm";


function index(props) {


  const router = useRouter()

  const [currentBot, setCurrentBot] = React.useState(null)





  React.useEffect(() => {
    setCurrentBot(props.currentBot)
  }, [props.currentBot])



  React.useEffect(() => {
    //console.log(router.query, "all kinda queries")
  }, [router.query])



  return (
    <div>
       <div className="container h-100">
        <div className="row  mt-5 pt-5">
            <div className="col-md-6 col-12">
                <div className={styles.crard_main_section}>
                    <div className="d-flex align-items-center mb-2 pb-1">
                    <img src={`${imageBaseURL}product-details.svg`} alt=""  className="mr-2"/><h1 style={{fontWeight:"600"}}> Safety Suite</h1>
                    </div>
                    <div className={styles.card_section1}>
                        <div className="mb-2">
                            <img src={`${imageBaseURL}maps.svg`} alt="" className="mr-2" />
                            <span>Clusters Live</span>
                        </div>
                        <p> South Asia (India) , LATAM (Guatemala,El Salvador) </p>
                    </div>
                    <p className="crard_main_section_p">A video analytics tool specifically designed for people’s health and safety. Get real time SMS, Whatsapp alerts, Web & Desktop Dashboards.</p>
                </div>
<div className={`${styles.blue_card_section} col-12 col-md-4`}>  
                <div class="justify-content-center">
                    <h1>24x7</h1>
                    <p>availability</p>
                </div>                    
{/* <div className="row">
                        <div className=" col-6" >
                            <h1>24x7 safety for your teams</h1>
                        </div>
                        <div className="col-6 " >
                            <p>Availability</p>
                        </div>
                    </div>  */}
                </div>
            </div>
            <div className="col-md-6 col-12 align-self-end">
                 <div className={styles.iframe_section} dangerouslySetInnerHTML={{ __html: `<iframe src=${imageBaseURL}suit.mp4 />`}} />
            </div>
        </div>
       </div>
       <div className={styles.benefits_section}>
            <div className="container h-100">
                <div  className="mb-5">
                <h1>Used By</h1>
                </div>
                <div className={styles.Frist_section}>
                <div className="row ">
                    <div className="col-md-3 col-6  mb-4 mb-md-0">
                        <div className={styles.cards_benefits}>
                            <img src={`${imageBaseURL}suit.svg`} alt="" />
                            <p>Factories</p>
                        </div>
                    </div>
                    <div className="col-md-3 col-6 mb-4 mb-md-0">
                        <div className={styles.cards_benefits}>
                            <img src={`${imageBaseURL}suit1.svg`} alt="" />
                            <p>Construction sites</p>
                        </div>
                    </div>
                    <div className="col-md-3 col-6 mb-4 mb-md-0">
                        <div className={styles.cards_benefits}>
                            <img src={`${imageBaseURL}suit2.svg`} alt="" />
                            <p>Warehouses </p>
                            {/* <p>Process</p> */}
                        </div>
                    </div>
                    <div className="col-md-3 col-6 mb-4 mb-md-0">
                        <div className={styles.cards_benefits}>
                            <img src={`${imageBaseURL}suit3.svg`} alt="" />
                            <p>Travel Safety</p>
                        </div>
                    </div>
                </div>
                </div>
                <div className="row">
                    <div className="col-md-6 text-center">
                         <div  className={`text-center position-relative ${styles.cards_benefits_card}`}>
                         <img src={`${imageBaseURL}robo.png`} alt="" />
                            <div className="back_image">
                                <img src={`${imageBaseURL}dot.svg`} className={styles.img_1} alt="" />
                                <img src={`${imageBaseURL}dot1.svg`} className={styles.img_2} alt="" />
                                <img src={`${imageBaseURL}dot2.svg`} className={styles.img_3} alt="" />
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6">
                        <h2 className="" style={{fontWeight:"600"}}>Safety Solution</h2>
                        <p className="mb-4">Let's be all in Safety!</p>
                        <ol>
<li >
                                    <div>
                                        <h3 style={{color:'#1F36C7'}} >
                                        Detection Systems
                                        </h3>
                                        <p>
                                        Helmets, Face Shields, Safety Shoes, Goggles, Hand Gloves
                                        </p>
                                    </div>
                                </li>
                            <li >
                                <div>
                                    <h3 style={{color:'#1F36C7'}} >Intrusion Detection </h3>
                                    <p>Detects any unauthorised access to the restricted areas</p>
                                </div>
                            </li>
                            <li >
                                <div>
                                    <h3 style={{color:'#1F36C7'}} > COVID Appropriate</h3>
                                    <p>Detects violations in social distancing, sanitisation, and more</p>
                                </div>
                            </li>
                            <li >
                                <div>
                                    <h3 style={{color:'#1F36C7'}} > Handrail Compliance</h3>
                                    <p>Capability to prevent 'slip / trip and fall' accidents at workplace</p>
                                </div>
                            </li>                        
</ol>
                    </div>
                </div>
            </div>
        </div>
    </div>
  );
}

export default index;

